/**
 * Sign/zero handling for change-styled numbers (PnL, deltas).
 * A value within the precision threshold renders as an UNSIGNED zero —
 * a bare `isUp ? '+' : '-'` ternary here once regressed to "-0" on every
 * flat PnL row (isUp === null fell into the '-' branch).
 */
export const resolveChangeDisplay = (parseValue: number, precision: number, isChange: boolean, showSign: boolean) => {
  const threshold = Math.pow(10, -precision);
  const nearZero = Math.abs(parseValue) <= threshold;
  const isUp = nearZero ? null : parseValue > 0;
  const finalValue = nearZero ? 0 : parseValue;
  const sign = isChange && showSign && isUp !== null ? (isUp ? '+' : '-') : '';
  return { isUp, finalValue, sign };
};
